<template>
    <div class="home text-center">
        <h3>Página não encontrada ou o recurso procurado não está disponível.</h3>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    components: { },
    data: function() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        
    }
}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
